import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'text-component',
  styleUrls: ['text-component.scss'],
  shadow: true,
})
export class TextComponent {
  @Prop() variation: 'super' | 'title' | 'body';

  render() {
    return (
      <div class={this.variation}>
        <slot />
      </div>
    );
  }
}
